import React from 'react';

export const Widerruf = () => {
  return (
    <div style={{
      minHeight: '100vh',
      padding: 'var(--spacing-giant) 0',
      background: 'var(--bg-page)'
    }}>
      <div className="container" style={{ maxWidth: '900px' }}>
        <h1 className="display-medium" style={{ marginBottom: 'var(--spacing-xl)' }}>
          Widerrufsbelehrung
        </h1>

        <section style={{ marginBottom: 'var(--spacing-xl)' }}>
          <h2 className="heading-2" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Widerrufsrecht
          </h2>
          <p className="body-medium" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen.
          </p>
          <p className="body-medium" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag des Vertragsabschlusses.
          </p>
        </section>

        <section style={{ marginBottom: 'var(--spacing-xl)' }}>
          <h2 className="heading-2" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Ausübung des Widerrufsrechts
          </h2>
          <p className="body-medium" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Um Ihr Widerrufsrecht auszuüben, müssen Sie uns mittels einer eindeutigen Erklärung (z.B. per E-Mail oder Brief) über Ihren Entschluss, diesen Vertrag zu widerrufen, informieren. Sie können dafür das beigefügte Muster-Widerrufsformular verwenden, das jedoch nicht vorgeschrieben ist.
          </p>
          <p className="body-medium" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Die Kontaktdaten entnehmen Sie bitte dem Impressum dieser Website.
          </p>
          <p className="body-medium" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung über die Ausübung des Widerrufsrechts vor Ablauf der Widerrufsfrist absenden.
          </p>
        </section>

        <section style={{ marginBottom: 'var(--spacing-xl)' }}>
          <h2 className="heading-2" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Folgen des Widerrufs
          </h2>
          <p className="body-medium" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen erhalten haben, unverzüglich und spätestens binnen vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über Ihren Widerruf dieses Vertrags bei uns eingegangen ist. Für diese Rückzahlung verwenden wir dasselbe Zahlungsmittel, das Sie bei der ursprünglichen Transaktion eingesetzt haben, es sei denn, mit Ihnen wurde ausdrücklich etwas anderes vereinbart.
          </p>
        </section>

        <section style={{ marginBottom: 'var(--spacing-xl)' }}>
          <h2 className="heading-2" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Besondere Hinweise zu digitalen Inhalten
          </h2>
          <p className="body-medium" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Ihr Widerrufsrecht erlischt vorzeitig, wenn:
          </p>
          <ul style={{ marginLeft: '24px', marginBottom: 'var(--spacing-medium)' }}>
            <li className="body-medium" style={{ marginBottom: 'var(--spacing-small)' }}>
              Sie ausdrücklich zugestimmt haben, dass wir mit der Ausführung des Vertrags vor Ablauf der Widerrufsfrist beginnen, und
            </li>
            <li className="body-medium" style={{ marginBottom: 'var(--spacing-small)' }}>
              Sie Ihre Kenntnis davon bestätigt haben, dass Sie durch Ihre Zustimmung mit Beginn der Ausführung des Vertrags Ihr Widerrufsrecht verlieren.
            </li>
          </ul>
          <p className="body-medium" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Dies betrifft insbesondere den sofortigen Zugang zu digitalen Inhalten wie Online-Kursen, Video-Lektionen und PDF-Downloads.
          </p>
        </section>

        <section style={{ marginBottom: 'var(--spacing-xl)' }}>
          <h2 className="heading-2" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Dienstleistungen (Coaching, Beratung, Personal Training)
          </h2>
          <p className="body-medium" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Haben Sie verlangt, dass die Dienstleistungen (z.B. Beratung, Coaching oder Personal Training) während der Widerrufsfrist beginnen sollen, so haben Sie uns einen angemessenen Betrag zu zahlen, der dem Anteil der bis zu dem Zeitpunkt, zu dem Sie uns von der Ausübung des Widerrufsrechts hinsichtlich dieses Vertrags unterrichten, bereits erbrachten Dienstleistungen im Vergleich zum Gesamtumfang der im Vertrag vorgesehenen Dienstleistungen entspricht.
          </p>
          <p className="body-medium" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Das Widerrufsrecht erlischt bei vollständig erbrachter Dienstleistung, wenn Sie ausdrücklich zugestimmt haben, dass mit der Ausführung vor Ablauf der Widerrufsfrist begonnen wird, und zur Kenntnis genommen haben, dass Sie Ihr Widerrufsrecht bei vollständiger Vertragserfüllung verlieren.
          </p>
        </section>

        <section style={{ marginBottom: 'var(--spacing-xl)' }}>
          <h2 className="heading-2" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Muster-Widerrufsformular
          </h2>
          <div style={{
            background: 'var(--bg-subtle)',
            padding: 'var(--spacing-large)',
            borderRadius: '24px',
            border: '2px solid var(--border-medium)'
          }}>
            <p className="body-medium" style={{ marginBottom: 'var(--spacing-medium)' }}>
              Wenn Sie den Vertrag widerrufen wollen, können Sie dieses Formular verwenden:
            </p>
            <p className="body-medium" style={{ marginBottom: 'var(--spacing-small)', fontStyle: 'italic' }}>
              An: [Adresse aus Impressum einfügen]
            </p>
            <p className="body-medium" style={{ marginBottom: 'var(--spacing-small)', fontStyle: 'italic' }}>
              Hiermit widerrufe(n) ich/wir (*) den von mir/uns (*) abgeschlossenen Vertrag über den Kauf der folgenden Waren (*) / die Erbringung der folgenden Dienstleistung (*)
            </p>
            <p className="body-medium" style={{ marginBottom: 'var(--spacing-small)', fontStyle: 'italic' }}>
              Bestellt am (*) / erhalten am (*)
            </p>
            <p className="body-medium" style={{ marginBottom: 'var(--spacing-small)', fontStyle: 'italic' }}>
              Name des/der Verbraucher(s)
            </p>
            <p className="body-medium" style={{ marginBottom: 'var(--spacing-small)', fontStyle: 'italic' }}>
              Anschrift des/der Verbraucher(s)
            </p>
            <p className="body-medium" style={{ marginBottom: 'var(--spacing-small)', fontStyle: 'italic' }}>
              Unterschrift des/der Verbraucher(s) (nur bei Mitteilung auf Papier)
            </p>
            <p className="body-medium" style={{ fontStyle: 'italic' }}>
              Datum
            </p>
            <p className="body-medium" style={{ marginTop: 'var(--spacing-medium)', fontSize: '0.875rem' }}>
              (*) Unzutreffendes streichen.
            </p>
          </div>
        </section>

        <p className="body-medium" style={{ fontStyle: 'italic', color: 'var(--text-light)' }}>
          Stand: Januar 2025
        </p>
      </div>
    </div>
  );
};
